<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>

document.title='易充云充电运营平台';
export default {
  name: 'App',
  components: {

  },
  created(){
    //菜单权限设置
    // this.$store.state.authority = localStorage.getItem('authority')?localStorage.getItem('authority'):[];
  },
  mounted(){
    // this.getStationList();
  },
  methods:{
    // getStationList(){
    //   //获取场站列表
    //   let that = this;
    //   that.$axios.post("platform-server/station/list",{}).then(result => {
    //     // console.log(result);
    //     if(result.code==200){
    //       this.$store.state.stationList = result.data;}
    //     })
    // }
  }
}
</script>

<style>
/* #app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
} */
* {
		margin: 0;
		padding: 0;
	}
	body {
		overflow: hidden;
		font: 14px "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
	}
  html,body,#app{
    margin: 0;
		padding: 0;
    height: 100vh;
  }
	a {
		text-decoration: none;
	}
  .pagination {
        margin-top: 20px;
        text-align: center;
        display: flex;
        justify-content: right;
        align-items: center
    }
  .table_wrapper{
    width: 100%;
    border-radius: 5px;
  }
</style>